import request from '@/utils/request'
import URL from './urlTranslator'

// 获取空运港口列表
export function getSysOperationRequirementDescriptionList(params) {
  return request({
    url: URL.mdm.operation.operationRequirementDescrition,
    method: 'get',
    params
  })
}

// 平台新增基础港口
export function addOperationRequirementDescription(data) {
  return request({
    url: URL.mdm.operation.operationRequirementDescrition,
    method: 'post',
    data
  })
}

// 编辑空运港口
export function updateOperationRequirementDescription(data) {
  return request({
    url: URL.mdm.operation.operationRequirementDescrition,
    method: 'put',
    data
  })
}

// 批量删除空运港口
export function batchDelOperationRequirementDescription(uuidList) {
  const data = [...uuidList]
  return request({
    url: URL.mdm.operation.operationRequirementDescrition,
    method: 'delete',
    data
  })
}

// 获取操作描述业务类型选项集合
export function getSysOperationLobOptionList() {
  return request({
    url: URL.mdm.operation.operationLobTypeOption,
    method: 'get'
  })
}

// 获取操作描述操作类型选择集合
export function getSysOperationRequirementOptionList() {
  return request({
    url: URL.mdm.operation.operationRequirementTypeOption,
    method: 'get'
  })
}

// 平台新增基础港口
export function queryOperationRequirementDescription(data) {
  return request({
    url: URL.mdm.operation.queryOperationRequirementDescription,
    method: 'post',
    data
  })
}

// 获取特殊操作代码
export function getSpecialOperationCodeList(data) {
  return request({
    url: URL.mdm.operation.getSpecialOperationCodeList,
    method: 'post',
    data
  })
}
